import React from 'react'
import RiskNewsItem from '../RiskNewsItem/RiskNewsItem';
import { RiskData } from "../../../Library/Data/RiskData";

import styles from './RiskNews.module.scss';
import { Dropdown } from 'react-bootstrap';
import VCard from '../../../../components/VCard/VCard';

export default function RiskNews() {
  return (
    <>
      <h3>Risk news</h3>
      <div className={styles.buttonWrapper}>
        <Dropdown>
          <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
            Filters
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item>In Progress</Dropdown.Item>
            <Dropdown.Item>Completed</Dropdown.Item>
            <Dropdown.Item>Not Started</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <div className={styles.layouts}>
          <span className='icon-grid'></span>
          <span className={styles.rowsIcon}></span>
          <span className={styles.rowsThreeIcon}></span>
        </div>
      </div>
      <div className={styles['news-list']}>
        {RiskData.map((risk) => (
          <div key={risk.id} className="col-lg-6">
            <VCard
              image={risk.image}
              risk={risk.risk}
              title={risk.title}
              details={risk.details}
              data={risk.data}
              customStyles={{marginRight:'1rem', marginBottom: '1rem'}}
            />
          </div>
        ))}
      </div>
    </>
  )
}
